function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import Action from "../types/Action";
var Droit = /*#__PURE__*/function () {
  function Droit(objet, nomObjet, droit) {
    this.objet = objet;
    this.nomObjet = nomObjet;
    this.droit = droit;
  }
  var _proto = Droit.prototype;
  _proto.hasDroitTout = function hasDroitTout() {
    return this.droit === 'TOUT';
  };
  _proto.hasDroitCreation = function hasDroitCreation() {
    return this.hasDroitTout() || this.droit.includes('+CR');
  };
  _proto.hasDroitModification = function hasDroitModification() {
    return this.hasDroitTout() || this.droit.includes('+MO');
  };
  _proto.hasDroitSuppression = function hasDroitSuppression() {
    return this.hasDroitTout() || this.droit.includes('+SU');
  };
  _proto.hasDroitVoir = function hasDroitVoir() {
    return this.hasDroitTout() || this.droit.includes('+') || this.droit.includes('-') || this.droit === 'VOIR';
  };
  _proto.hasDroitAucun = function hasDroitAucun() {
    return this.droit === 'AUCUN';
  };
  _proto.isAllow = function isAllow(action) {
    switch (action) {
      case Action.TOUT:
        return this.hasDroitTout();
      case Action.CREATION:
        return this.hasDroitCreation();
      case Action.MODIFICATION:
        return this.hasDroitModification();
      case Action.SUPPRESSION:
        return this.hasDroitSuppression();
      case Action.VOIR:
        return this.hasDroitVoir();
      case Action.AUCUN:
        return this.hasDroitAucun();
      default:
        throw new Error('Unknown action');
    }
  };
  _createClass(Droit, [{
    key: "sujet",
    get: function get() {
      return this.objet + "." + this.nomObjet;
    }
  }]);
  return Droit;
}();
export default Droit;